import {
  isSavedPathCollapsingRule,
  ViewStatePathCollapsingRule,
} from './types';
import { CollapsePathsCommands } from './collapsePathsCommands';
import { IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { Box, FlexBox, Stack } from '@ardoq/layout';
import { PathCollapsingRulePathSummary } from './PathCollapsingRulePathSummary';
import { TextOverflow } from '@ardoq/popovers';
import { Switch } from '@ardoq/forms';
import { t, type I18nLocale } from '@ardoq/i18n';

type PathCollapsingRuleItemProps = {
  rule: ViewStatePathCollapsingRule;
  commands: CollapsePathsCommands;
  isEditingAnotherRule: boolean;
  i18nLocale: I18nLocale;
};

const PathCollapsingRuleItem = ({
  rule,
  commands,
  isEditingAnotherRule,
  i18nLocale,
}: PathCollapsingRuleItemProps) => {
  if (!isSavedPathCollapsingRule(rule)) {
    return null;
  }
  return (
    <Box borderWidth={1} borderRadius="r8" padding="medium" paddingTop="small">
      <Stack gap="small">
        <FlexBox align="center" justify="space-between">
          <TextOverflow
            style={{ fontSize: '18px', fontWeight: 600 }}
            content={rule.displayText}
          >
            {rule.displayText}
          </TextOverflow>
          <FlexBox gap="xsmall">
            <IconButton
              label={t(
                i18nLocale,
                'viewpointBuilder:collapsePaths.rule.edit',
                'Edit'
              )}
              iconName={IconName.EDIT}
              onClick={() =>
                commands.editPathCollapsingRule(rule.referenceTypeId)
              }
              isDisabled={isEditingAnotherRule}
            />
            <IconButton
              label={t(
                i18nLocale,
                'viewpointBuilder:collapsePaths.rule.delete',
                'Delete'
              )}
              iconName={IconName.DELETE}
              onClick={() =>
                commands.deletePathCollapsingRule(rule.referenceTypeId)
              }
            />
          </FlexBox>
        </FlexBox>
        {isSavedPathCollapsingRule(rule) && (
          <FlexBox align="center" gap="xsmall">
            <Switch
              name={`rule-${rule.displayText}-${rule.referenceTypeId}`}
              label={t(
                i18nLocale,
                'viewpointBuilder:collapsePaths.rule.isActive',
                'is active'
              )}
              isChecked={rule.isActive}
              onChange={() =>
                commands.collapsingRuleIsActiveToggled(
                  rule.referenceTypeId,
                  !rule.isActive
                )
              }
            />
          </FlexBox>
        )}
        <PathCollapsingRulePathSummary
          rule={rule}
          commands={commands}
          i18nLocale={i18nLocale}
        />
      </Stack>
    </Box>
  );
};

export { PathCollapsingRuleItem };
